import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "VLSI Foundations & Semiconductor Basics",
    description:
      "Understanding microelectronics & chip evolution, Role of VLSI in modern devices (mobiles, IoT, AI chips), Basics of semiconductors conductors & insulators, p-type n-type materials & doping concepts, Introduction to fabrication technology",
  },
  {
    title: "Digital Electronics & Logic Design Essentials",
    description:
      "Number systems & Boolean algebra, Logic gates combinational & sequential circuits, Flip-flops registers counters & multiplexers, Minimization techniques (K-map), Real circuit representation and timing concepts",
  },
  {
    title: "CMOS Technology & Circuit Design Principles",
    description:
      "CMOS inverter operation, NMOS & PMOS characteristics, Switching power dissipation & noise margins, Static & dynamic CMOS logic, Designing basic CMOS circuits",
  },
  {
    title: "VHDL / Verilog HDL for Hardware Modeling",
    description:
      "Introduction to HDL languages, Data types operators & syntax, Behavioral dataflow & structural modeling, Writing testbenches & simulation, Hands-on digital circuit programming",
  },
  {
    title: "RTL Design, Synthesis & Hardware Implementation",
    description:
      "Understanding RTL (Register Transfer Level), FSM (Finite State Machine) design, Synthesizing HDL code into gate-level circuits, Constraints timing optimization & area utilization, Gate-level simulation & validation",
  },
  {
    title: "ASIC Design Flow & Standard Cell Methodology",
    description:
      "Complete ASIC flow from RTL → GDSII, Standard cells libraries & technology files, Logic synthesis floor planning & placement, Routing with EDA tools, Introduction to industry-standard ASIC flows",
  },
  {
    title: "FPGA Architectures & Implementation Flow",
    description:
      "Basics of FPGA & configurable logic blocks, LUTs flip-flops DSPs & block RAM, FPGA design flow using synthesis tools, Implementing RTL on real FPGA boards, Programming with Xilinx/Intel tools",
  },
  {
    title: "Physical Design, STA & Timing Closure",
    description:
      "Floor planning power planning & clock tree synthesis, Static Timing Analysis (STA) fundamentals, Setup time hold time slack & violations, Fixing timing errors & closing timing, Final design sign-off",
  },
  {
    title: "DFT, Verification & Testing Techniques",
    description:
      "Design for Testability (DFT) essentials, Scan chains ATPG & fault modeling, Functional & formal verification, Using simulation tools for testing, Ensuring chip reliability & manufacturing success",
  },
  {
    title: "Capstone VLSI Project & Career Preparation",
    description:
      "End-to-end VLSI design project (RTL → implementation), Working on FPGA or ASIC mini-project, Documentation & design reports, Portfolio preparation for VLSI roles, Interview prep for RTL engineer Verification engineer & Physical design roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
